<template>
  <div class="vx-row">
    <div class="vx-card w-full no-box-shadow overflow-hidden mb-base">
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <vs-prompt
          :title="$t('skillDetails.action.a1')"
          :accept-text="$t('skillDetails.action.a2')"
          :cancel-text="$t('skillDetails.action.a6')"
          @cancel="custom_development_action=''"
          @accept="addCustomDevelopmentAction"
          @close="custom_development_action=''"
          :is-valid= "custom_development_action!==''"
          :active.sync="add_custom_development_action_active">
          <div class="con-exemple-prompt">
            <div class="mb-3">{{ $t("skillDetails.action.a3") }}</div>
            <vs-input class="w-full" :placeholder="$t('skillDetails.action.a4')" v-model="custom_development_action"/>
          </div>
        </vs-prompt>

        <div>
          <!-- SECTION: DOING (WIP) AND PINNED (TODO) -->
          <!-- 🔥 CHANGED: Now accepts both 'wip' and 'todo' statuses -->
          <div  class="p-6" style="height: auto">
            <template  v-for="da in developmentActions">
              <div :key="da.id"  v-if="da.status==='wip' || da.status==='todo'" class="p-1 flex items-center justify-between">
                <div class="items-left">
                  <p v-if="da.da !== undefined" style="font-size: 14px;">{{ da.da }}</p>
                  <p v-else style="font-size: 14px;">{{ da.developmentAction }}</p>
                </div>
                <div class="p-1" style="float: right;" >
                  <ThreeSwitchToggle 
                    :da="da" 
                    :progressStatus="progressStatus" 
                    :totalActions="developmentActions.length" 
                    @status-updated="handleTaskUpdate"
                  />
                </div>
              </div>
            </template>
          </div>

          <div class="">
            <vs-collapse accordion :key="collapseKey">
              
              <!-- COLLAPSE ITEM 1: DEFINE DEVELOPMENT ACTION -->
              <vs-collapse-item >
                <div slot="header"
                  v-if="(progressStatus !== 'complete' && userType === 'coach' && terminology==2) || (progressStatus !== 'complete' && userType === 'trainee')"
                  @click="add_custom_development_action_active=true"
                  class="p-2 flex items-center feather-icon select-none relative text-primary">
                  <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"  width="30px" height="30px" class="rounded-full" />
                  <h6 class="items-left ml-2">{{ $t("skillDetails.action.a5") }}</h6>
                </div>
                
                <!-- 🔥 CHANGED: Removed the 'todo' loop from here so pinned tasks don't show up here anymore! -->
                <div class="w-full collapse-inner-wrapper" style="min-height: 1px;">
                  <!-- Intentionally left empty. Custom actions automatically become 'wip' and go to the top list -->
                </div>
              </vs-collapse-item>

              <!-- COLLAPSE ITEM 2: SUGGESTED (UNKNOWN) -->
              <vs-collapse-item>
                <div slot="header" class="p-2 flex items-center feather-icon select-none relative text-primary">
                  <feather-icon icon="ListIcon" svgClasses="h-4 w-4"  width="30px" height="30px" class="rounded-full" />
                  <h6 class="items-left ml-2">{{ $t("skillDetails.action.a7") }}</h6>
                </div>

                <div class="w-full collapse-inner-wrapper" style="min-height: 1px;">
                  <template v-for="da in developmentActions">
                    <div v-if="da.status==='unknown'" :key="da.id" class="p-1 flex items-center justify-between">
                      <div class="items-left">
                        <p v-if="da.da !== undefined" style="font-size: 14px;">{{ da.da }}</p>
                        <p v-else style="font-size: 14px;">{{ da.developmentAction }}</p>
                      </div>
                      <div class="p-1" style="float: right;">
                        <ThreeSwitchToggle 
                          :da="da" 
                          :progressStatus="progressStatus" 
                          :totalActions="developmentActions.length" 
                          @status-updated="handleTaskUpdate"
                        />
                      </div>
                    </div>
                  </template>
                </div>
              </vs-collapse-item>

              <!-- COLLAPSE ITEM 3: DONE -->
              <vs-collapse-item >
                <div slot="header" class="flex items-center p-2 feather-icon select-none relative text-primary">
                      <feather-icon icon="CheckSquareIcon" svgClasses="h-4 w-4"  width="30px" height="30px" class="rounded-full" />
                  <h6 class="items-left ml-2">{{ $t("skillDetails.action.a8") }}</h6>
                </div>

                <div class="w-full collapse-inner-wrapper" style="min-height: 1px;">
                  <template v-for="da in developmentActions">
                    <div v-if="da.status==='done'" :key="da.id" class="p-1 flex items-center justify-between">
                      <div class="items-left">
                        <p v-if="da.da !== undefined" style="font-size: 14px;">{{ da.da }}</p>
                        <p v-else style="font-size: 14px;">{{ da.developmentAction }}</p>
                      </div>
                      <div class="p-1" style="float: right;"  >
                        <ThreeSwitchToggle 
                          :da="da" 
                          :progressStatus="progressStatus" 
                          :totalActions="developmentActions.length" 
                          @status-updated="handleTaskUpdate"
                        />
                      </div>
                    </div>
                  </template>
                </div>
              </vs-collapse-item>

            </vs-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ThreeSwitchToggle from '../components/ThreeSwitchToggle';
import uuid4 from 'uuid4'
import axios from 'axios';

export default {
  name: "Feedback",
  props: ['progressStatus','terminology'],
  data() {
    return {
      userType: this.$store.state.AppActiveUser.userType, 
      CCD: this.$t("addNewSkill.data"),
      developmentActions: [], 
      custom_development_action: '', 
      add_custom_development_action_active: false, 
      status: null, collapseKey: 0,
      calcTimeout: null // For debouncing the progress API
    };
  },
  components: { ThreeSwitchToggle },
  watch: {
    developmentActions: {
      handler(newVal) {
        if(newVal && newVal.length > 0) {
          if(this.calcTimeout) clearTimeout(this.calcTimeout);
          this.calcTimeout = setTimeout(() => {
            this.recalculateProgress();
          }, 1000); // 1-second debounce to prevent spamming API
        }
      },
      deep: true
    }
  },
  methods: {
    handleTaskUpdate({ id, status }) {
      const index = this.developmentActions.findIndex(da => da.id === id);
      
      if (index !== -1) {
        const updatedTask = { ...this.developmentActions[index], status: status };
        this.developmentActions.splice(index, 1, updatedTask);
      }
    },
    
    _searchInDataset(dataset, targetId) {
      if (!dataset || !targetId) return null;
      let parts = targetId.split("-");
      for (let key in dataset) {
        if (dataset[key] && dataset[key].competencies) {
          let comps = dataset[key].competencies;
          if (Array.isArray(comps)) {
            let found = comps.find(c => c.id === targetId);
            if (found) return found;
          } else {
            for (let k in comps) {
              if (comps[k] && comps[k].id === targetId) return comps[k];
              if (key === parts[0] && k === parts[1]) return comps[k];
            }
          }
        }
      }
      return null;
    },
    getSkillData(targetId) {
      if (!targetId) return null;

      let parts = targetId.split("-");
      if (parts.length >= 3) {
        targetId = `${parts[0]}-${parts[1]}`;
      }

      let locale = window.$cookies.get('locale') || (this.$i18n && this.$i18n.locale) || 'en';
      if (locale.includes('-')) {
        locale = locale.split('-')[0];
      }

      let patterns = [];
      if (targetId.startsWith('eg-') || targetId.startsWith('nb-') || targetId.startsWith('ei-') || targetId.startsWith('es-')) {
        patterns.push(`i18n-${locale}-deep-Data`);         
      } else if (targetId.startsWith('sc-')) {
        patterns.push(`i18n-${locale}-pci-Data-Coach`, `i18n-${locale}-pci-Data`); 
      } else if (targetId.startsWith('lt-') || targetId.startsWith('l-')) {
        patterns.push(`i18n-${locale}-Data-DPM`);          
      } else if (targetId.startsWith('pt-')) {
        patterns.push(`i18n-${locale}-peopletree-Data`);   
      }

      const allPatterns = [
        `i18n-${locale}-deep-Data`,
        `i18n-${locale}-pci-Data-Coach`,
        `i18n-${locale}-pci-Data`,
        `i18n-${locale}-peopletree-Data`,
        `i18n-${locale}-Data-DPM`,
        `i18n-${locale}-Data`
      ];

      allPatterns.forEach(p => {
        if (!patterns.includes(p)) patterns.push(p);
      });

      if (locale !== 'en') {
        let enPatterns = [];
        if (targetId.startsWith('eg-') || targetId.startsWith('nb-') || targetId.startsWith('ei-') || targetId.startsWith('es-')) {
          enPatterns.push('i18n-en-deep-Data');
        } else if (targetId.startsWith('sc-')) {
          enPatterns.push('i18n-en-pci-Data-Coach', 'i18n-en-pci-Data');
        } else if (targetId.startsWith('lt-') || targetId.startsWith('l-')) {
          enPatterns.push('i18n-en-Data-DPM');
        } else if (targetId.startsWith('pt-')) {
          enPatterns.push('i18n-en-peopletree-Data');
        }

        const allEnPatterns = [
          'i18n-en-deep-Data',
          'i18n-en-pci-Data-Coach',
          'i18n-en-pci-Data',
          'i18n-en-peopletree-Data',
          'i18n-en-Data-DPM',
          'i18n-en-Data'
        ];

        allEnPatterns.forEach(p => {
          if (!enPatterns.includes(p) && !patterns.includes(p)) {
            enPatterns.push(p);
          }
        });
        patterns = patterns.concat(enPatterns);
      }

      for (let i = 0; i < patterns.length; i++) {
        try {
          const fallbackModule = require(`@/i18n/${patterns[i]}.js`);
          const fallbackData = fallbackModule.default || fallbackModule;
          if (fallbackData && fallbackData.addNewSkill && fallbackData.addNewSkill.data) {
            let found = this._searchInDataset(fallbackData.addNewSkill.data, targetId);
            if (found) return found;
          }
        } catch (err) {}
      }

      return this._searchInDataset(this.CCD, targetId);
    },

    addCustomDevelopmentAction() {
      const customDA = { 
        developmentAction: this.custom_development_action, 
        developmentActionId: `custom_da_${ uuid4()}`, 
        status: 'wip', 
        traineeCompetenciesId: this.$route.params.traineeCompetenciesId 
      };
      
      this.$store.dispatch("developmentActions/addDA", customDA)
        .then(res => {
          this.developmentActions.unshift({
            da: customDA.developmentAction,
            id: customDA.developmentActionId,
            status: customDA.status
          });
          this.add_custom_development_action_active = false;
          this.custom_development_action = '';
        })
        .catch(e => { console.error("Error saving custom action:", e); });
    },

    recalculateProgress() {
      const id = this.$route.params.traineeCompetenciesId;
      
      const totalActions = this.developmentActions.length;
      if(totalActions === 0) return;

      const completedCount = this.developmentActions.filter(da => da.status === 'done').length;
      const doingCount = this.developmentActions.filter(da => da.status === 'wip').length;

      const calculatedProgress = Math.round((completedCount / totalActions) * 100);
      const calculatedPractice = Math.round((doingCount / totalActions) * 100);

      this.$store.dispatch("trainee-competencies/get", id).then(traineeComp => {
        if (!traineeComp) return;

        const compDetails = this.getSkillData(traineeComp.competencyId);
        const actualSkillName = compDetails ? (compDetails.comp || compDetails.name) : (traineeComp.skill_name || "Custom Skill");

        let actualIcon = compDetails && compDetails.icon ? compDetails.icon : "";
        if (!actualIcon || actualIcon === "") {
            actualIcon = `https://api-core-gateway.getboarded.com/assets/competencies/${traineeComp.competencyId}.svg`;
        }

        let initialLevelVal = traineeComp.initialLevel !== undefined && traineeComp.initialLevel !== null 
                      ? parseInt(traineeComp.initialLevel) 
                      : 5;
                      
        const actualRelevancy = traineeComp.relevancy !== undefined && traineeComp.relevancy !== null 
                                ? traineeComp.relevancy 
                                : (initialLevelVal * 10);

        const orgId = this.$store.state.activeCoachOrgId || "default_org";
        const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
        const email = window.$cookies.get('email') || userInfo.email || "test@test.com";
        const userId = this.$store.state.AppActiveUser.usersId;

        const progressPayload = {
          user_id: String(userId),
          email: String(email),
          org_id: String(orgId),
          competency_id: String(traineeComp.competencyId),
          skill_name: String(actualSkillName), 
          relevancy: parseInt(actualRelevancy), 
          progress: calculatedProgress,
          practice: calculatedPractice,
          total_actions: totalActions,
          doing_actions: doingCount,
          done_actions: completedCount,
          icon: String(actualIcon)
        };

        const baseUrl = "https://parser.ai.getboarded.com";
        axios.post(`${baseUrl}/api/coach/progress`, progressPayload)
          .then(() => {
            this.$emit("actionStatusChanged");
          })
          .catch(err => console.error("Error updating progress metrics:", err));
      }).catch(err => console.error(err));
    }
  },
  created() {
    this.$root.$on("force-progress-calc", this.recalculateProgress);
    const id = this.$route.params.traineeCompetenciesId;
    
    this.$store.dispatch("trainee-competencies/get", id).then(res => {
        let compId = res.competencyId; 
        
        this.$store.dispatch("trainee-competencies-prgms/find", { query: { traineeCompetenciesId: id } }).then(resPrgms => {
            let activePmIds = resPrgms && resPrgms.data ? resPrgms.data.map(item => item.progressMeasureId) : [];

            this.$store.dispatch("developmentActions/fetchDA", { query: { traineeCompetenciesId: id } }).then(resDA => {
                let foundDAs = [];
                let compDetails = this.getSkillData(compId);

                if (compDetails) {
                    if (compDetails.developmentActions) {
                        foundDAs = compDetails.developmentActions;
                    } else if (compDetails.progressMeasures) {
                        let merged = [];
                        if (Array.isArray(compDetails.progressMeasures)) {
                            compDetails.progressMeasures.forEach(pm => {
                                if ((activePmIds.length === 0 || activePmIds.includes(pm.id)) && pm.developmentActions) {
                                    merged = merged.concat(pm.developmentActions);
                                }
                            });
                        } else {
                            for (let k in compDetails.progressMeasures) {
                                let pm = compDetails.progressMeasures[k];
                                let isMatched = activePmIds.length === 0 || activePmIds.includes(pm.id) || activePmIds.includes(k);
                                if (isMatched && pm.developmentActions) {
                                    merged = merged.concat(pm.developmentActions);
                                }
                            }
                        }
                        foundDAs = merged;
                    }
                }

                this.developmentActions = foundDAs && foundDAs.length > 0 ? JSON.parse(JSON.stringify(foundDAs)) : [];
                for (const y in this.developmentActions) this.developmentActions[y]["status"] = "unknown";
                
                if (resDA && resDA.data) {
                    for (const cda in resDA.data) {
                        if(resDA.data[cda].developmentActionId.includes('custom_da')) {
                            const customDA = { da: resDA.data[cda].developmentAction, id: resDA.data[cda].developmentActionId, status: resDA.data[cda].status }
                            if(!this.developmentActions.some(e => e.id === customDA.id)) this.developmentActions.unshift(customDA)
                        }
                    }
                    if (resDA.total > 0) {
                        for (const x in resDA.data) {
                            for (const y in this.developmentActions) {
                               if (resDA.data[x].developmentActionId === this.developmentActions[y].id) {
                                    this.developmentActions[y]["status"] = resDA.data[x].status;
                                    this.developmentActions[y]["daId"] = resDA.data[x].id;
                                }
                            }
                        }
                        const unknown = []; const todo = []; const workInProgress = []; const completed = [];
                        for (const x in this.developmentActions) {
                            if (this.developmentActions[x].status === "unknown") unknown.push(this.developmentActions[x]);
                            else if (this.developmentActions[x].status === "todo") todo.push(this.developmentActions[x]);
                            else if (this.developmentActions[x].status === "wip") workInProgress.push(this.developmentActions[x]);
                            else completed.push(this.developmentActions[x]);
                        }
                        this.developmentActions = [];
                        for (const x in workInProgress) this.developmentActions.push(workInProgress[x]);
                        for (const x in todo) this.developmentActions.push(todo[x]);
                        for (const x in unknown) this.developmentActions.push(unknown[x]);
                        for (const x in completed) this.developmentActions.push(completed[x]);
                    }
                }
            }).catch(e=>{});
        }).catch(e=>{});
    }).catch(e=>{});
  },
  beforeDestroy() {
    this.$root.$off("force-progress-calc", this.recalculateProgress);
    if(this.calcTimeout) clearTimeout(this.calcTimeout);
    this.developmentActions = []; 
  },
  destroyed () { this.developmentActions = []; }
};
</script>
<style scoped>
  .vx-card-addDA { cursor: pointer; }
  .vx-card-addDA:hover { background: #F9F9F9; }
  .no-box-shadow { box-shadow: none !important; }
  .t-sd { white-space: normal !important; }
  .skill-icon { width: 25px; height: 25px; }
  .items-left{ text-align: left; text-align: -moz-left; text-align: -webkit-left; }
  .items-center{ text-align: center; text-align: -moz-center; text-align: -webkit-center; }
</style>